<template>
  <div class="cw-loader" v-show="show">
    <div class="cw-loader-content">
      <svg class="spinner-container" width="44px" height="44px" viewBox="0 0 52 52">
        <circle class="path" cx="26px" cy="26px" r="20px" fill="none" stroke-width="4px"></circle>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  data() {
    return {
      show: false
    };
  },
  created() {
    this.$loadingSpinner.loggingFn('LoadingSpinner::created()');

    this.$loadingSpinner.componentCallback = show => {
      this.$loadingSpinner.loggingFn('LoadingSpinner::callback()', show);
      this.show = show;
    };
  }
};
</script>

<style lang="scss" scoped>
.cw-loader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.6);

  &-content {
    width: 44px;
    height: 44px;
  }
}

.spinner-container {
  animation: rotate 2s linear infinite;
}

.spinner-container .path {
  stroke-dasharray: 1, 150; /* 1%, 101% circumference */
  stroke-dashoffset: 0;
  stroke: rgb(65, 170, 170);
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150; /* 1%, 101% circumference */
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150; /* 70%, 101% circumference */
    stroke-dashoffset: -35; /* 25% circumference */
  }
  100% {
    stroke-dasharray: 90, 150; /* 70%, 101% circumference */
    stroke-dashoffset: -124; /* -99% circumference */
  }
}
</style>
